interface ContentWrapperProps {
  condition: boolean;
  // eslint-disable-next-line no-unused-vars
  wrapper: (children: JSX.Element[]) => JSX.Element;
  children: JSX.Element[];
}

export const ContentWrapper = ({
  condition,
  wrapper,
  children,
}: ContentWrapperProps): JSX.Element => {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return condition ? wrapper(children) : <>{children}</>;
};
